import { useCallback } from 'react'
import PageBuilderModel from '@v4/store/builderStore/models/PageBuilder.model'
import PageBuilderSelector from '@v4/utils/selectors/PageBuilderSelector'
import useStyles from './AddSection.styled'

export const useAddSection = props => {
	const { onMouseEnter, onMouseLeave, index } = props
	const { setSidebarMode, setAdditionalIndex } = PageBuilderSelector.useActions()
	const classes = useStyles(props)

	const handleAddSection = useCallback(
		event => {
			event.stopPropagation()
			event.preventDefault()
			setSidebarMode(PageBuilderModel.SIDEBAR_MODE.ADDITION)
			setAdditionalIndex(index)
		},
		[index, setAdditionalIndex, setSidebarMode],
	)

	return [
		{ classes },
		{
			handleMouseEnter: onMouseEnter,
			handleMouseLeave: onMouseLeave,
			handleAddSection,
		},
	]
}
